import { TOB_IFRAME_URL_ACCOUNT_LIST, TOB_TARGET_ORIGIN } from '../../../config';
import { MessageIframe } from '../../message-type/message-iframe';
var TARGET_ORIGIN = TOB_TARGET_ORIGIN;
export var getEnterpriseListEventName = {
    ALREADY_IFRAME_GET_ACCOUNT_LIST_FROM_B: 'ALREADY_IFRAME_GET_ACCOUNT_LIST_FROM_B', // B侧管理账号iframe已加载监听器
    GET_ACCOUNT_LIST_FROM_B: 'GET_ACCOUNT_LIST_FROM_B', // 获取B侧账号列表
    DELETE_ACCOUNT_LIST_FROM_B: 'DELETE_ACCOUNT_LIST_FROM_B', // 删除B侧账号列表
    SUCCESS_GET_ACCOUNT_LIST_FROM_B: 'SUCCESS_GET_ACCOUNT_LIST_FROM_B',
    SUCCESS_DELETE_ACCOUNT_LIST_FROM_B: 'SUCCESS_DELETE_ACCOUNT_LIST_FROM_B',
};
var IFRAME_URL = TOB_IFRAME_URL_ACCOUNT_LIST;
var IFRAME_ID = 'iframe-to-manage-account-list';
var GetEnterpriseAccountListMessage = /** @class */ (function () {
    function GetEnterpriseAccountListMessage() {
        this.getAccountMessage = new MessageIframe(this.getAccountMessageCheckFn);
        this.iframeMountMessage = new MessageIframe(this.getIframeMountMessageCheckFn);
        this.deleteAccountMessage = new MessageIframe(this.getDeleteAccountMessageCheckFn);
    }
    GetEnterpriseAccountListMessage.prototype.connect = function () {
        this.getAccountMessage.connect();
        this.iframeMountMessage.connect();
        this.deleteAccountMessage.connect();
    };
    GetEnterpriseAccountListMessage.prototype.dispose = function () {
        this.getAccountMessage.dispose();
        this.iframeMountMessage.dispose();
        this.deleteAccountMessage.dispose();
    };
    /**
     * 创建iframe 在C域名下，获取B获取账号列表，账号B侧账号
     * @param iframeSrc iframe的地址
     * @param iframeId iframe的id
     */
    GetEnterpriseAccountListMessage.prototype.createGetAccountListIframe = function (hadMountCallback) {
        var _this = this;
        this.getAccountListIframeDom = this.createMessageIframe(function (iframeDom, hadMountFirst) {
            if (!hadMountFirst) {
                hadMountCallback === null || hadMountCallback === void 0 ? void 0 : hadMountCallback();
                return;
            }
            _this.getAccountMessage.setIframeDom(iframeDom, TARGET_ORIGIN);
            _this.deleteAccountMessage.setIframeDom(iframeDom, TARGET_ORIGIN);
        });
    };
    /**
     * 发送B侧账号列表的请求
     */
    GetEnterpriseAccountListMessage.prototype.sendAccountListMessage = function () {
        this.getAccountMessage.send({
            eventFromCDomain: getEnterpriseListEventName.GET_ACCOUNT_LIST_FROM_B,
        });
    };
    /**
     * 发送删除账号请求
     * @param cookie 删除账号的cookie
     */
    GetEnterpriseAccountListMessage.prototype.sendDeleteAccountMessage = function (cookie) {
        this.deleteAccountMessage.send({
            eventFromCDomain: getEnterpriseListEventName.DELETE_ACCOUNT_LIST_FROM_B,
            cookie: cookie,
        });
    };
    /**
     * 获取B侧账号列表
     * @param listener 监听器
     */
    GetEnterpriseAccountListMessage.prototype.getAccountListMessage = function (listener) {
        this.getAccountMessage.receive(listener);
    };
    /**
     * 获取iframe加载完成
     * @param listener 监听器
     */
    GetEnterpriseAccountListMessage.prototype.getIframeMountMessage = function (listener) {
        this.iframeMountMessage.receive(listener);
    };
    /**
     * B侧列表账号删除成功
     * @param listener 监听器
     */
    GetEnterpriseAccountListMessage.prototype.getDeleteAccountMessage = function (listener) {
        this.deleteAccountMessage.receive(listener);
    };
    GetEnterpriseAccountListMessage.prototype.createMessageIframe = function (hadMountCallback) {
        if (document.getElementById(IFRAME_ID)) {
            hadMountCallback(document.getElementById(IFRAME_ID), false);
            return document.getElementById(IFRAME_ID);
        }
        var iframe = document.createElement('iframe');
        iframe.src = IFRAME_URL;
        iframe.id = IFRAME_ID;
        iframe.style.visibility = 'hidden';
        iframe.style.width = '0px';
        iframe.style.height = '0px';
        document.body.appendChild(iframe);
        hadMountCallback(iframe, true);
        return iframe;
    };
    GetEnterpriseAccountListMessage.prototype.getAccountMessageCheckFn = function (message) {
        var data = message.data, origin = message.origin;
        if (origin === TARGET_ORIGIN
            && data.eventFromBDomain === getEnterpriseListEventName.SUCCESS_GET_ACCOUNT_LIST_FROM_B) {
            return true;
        }
        return false;
    };
    GetEnterpriseAccountListMessage.prototype.getIframeMountMessageCheckFn = function (message) {
        var data = message.data, origin = message.origin;
        if (origin === TARGET_ORIGIN
            && data.eventFromBDomain === getEnterpriseListEventName.ALREADY_IFRAME_GET_ACCOUNT_LIST_FROM_B) {
            return true;
        }
        return false;
    };
    GetEnterpriseAccountListMessage.prototype.getDeleteAccountMessageCheckFn = function (message) {
        var data = message.data, origin = message.origin;
        if (origin === TARGET_ORIGIN
            && data.eventFromBDomain === getEnterpriseListEventName.SUCCESS_DELETE_ACCOUNT_LIST_FROM_B) {
            return true;
        }
        return false;
    };
    return GetEnterpriseAccountListMessage;
}());
export { GetEnterpriseAccountListMessage };
